// TODO: Why we're using png replacements?
//       all of our supported browsers have full support for SVG
//       http://caniuse.com/#feat=svg
import React from 'react';

export default class LogoImg extends React.Component {
  static propTypes = {
    pathSVG: React.PropTypes.string,
    pathPNG: React.PropTypes.string,
    altText: React.PropTypes.string,
    onLoad:  React.PropTypes.func
  };

  state = {
    hasErrored: false
  };

  onLoad = () => {
    if (typeof this.props.onLoad === 'function') {
      this.props.onLoad();
    }
  };

  onError = () => {
    // might go in an infinite loop if PNG errors
    if (!this.state.hasErrored) {
      this.setState({
        hasErrored: true
      });
    }
  };

  render () {
    const url = this.props.pathSVG && !this.state.hasErrored
    ? this.props.pathSVG
    : this.props.pathPNG;

    return <img
      className="logo__media"
      onLoad={this.onLoad}
      src={url}
      alt={this.props.altText}
      onError={this.onError}
      data-component="logoTag" />;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/logo/logoimg/index.js